// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GbsJ1","load8":"Spinner_load8__MoDIZ"};